import { FlowStateController } from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";

import {
    BackgroundEvents,
    EventsManager,
    FlowEvents,
    GameEvents,
    ReelsEvents,
} from "../../../abstracts/events/EventsManager";
import { AbstractFlowPresentation } from "../../../abstracts/flow/AbstractFlowStatePresentation";
import { AbstractGameMode } from "../../../abstracts/flow/AbstractGameMode";
import { shuffleArray } from "../../../abstracts/utils/ArrayUtils";
import { playSound } from "../../../abstracts/utils/SoundUtils";
import { normalConfig } from "../../UCConfig";
import { UgliestCatch } from "../../UgliestCatch";
import { UCSoundNames } from "../../assetsLoader/UCAssetsNames";
import { UCBackgroundView } from "../../modules/Background/UCBackgroundView";
import UCReel, { reelLandSounds } from "../../modules/Reels/UCReel";
import { UCReelsView } from "../../modules/Reels/UCReelsView";
import { BlockerStates, UCEvents } from "../../types/UCEnums";

export class UCNormalBetPresentation extends AbstractFlowPresentation {
    protected reelsView: UCReelsView;
    protected backgroundView: UCBackgroundView;

    protected ucReels: UCReel[] = [];

    constructor(protected id: string = `UCNormalBetPresentation`) {
        super(id);
    }

    protected handleEvents(): void {
        super.handleEvents();

        EventsManager.on(ReelsEvents.GET_REELS, (ucReels: UCReel[]) => {
            this.ucReels = ucReels;
        });

        EventsManager.on(FlowEvents.SKIP_NORMAL_BET, () => {
            this.flowPresentationTimeline.timeScale(normalConfig.skipCurrentSymbolsTimeScale!);
        });

        EventsManager.on(ReelsEvents.GET_REELS_VIEW, (reelsView: UCReelsView) => {
            this.reelsView = reelsView;
        });

        EventsManager.on(
            BackgroundEvents.GET_BACKGROUND_VIEW,
            (backgroundView: UCBackgroundView) => {
                this.backgroundView = backgroundView;
            }
        );

        EventsManager.on(UCEvents.CLOSE_BLOCKERS, () => {
            // const isXbet = UgliestCatch.model.data.enhancedBet;

            this.ucReels.forEach((reel) => {
                // reel.topBlocker.close(reel.reelId === 1 && isXbet);
                // reel.bottomBlocker.close(reel.reelId === 1 && isXbet);
                reel.topBlocker.close();
                reel.bottomBlocker.close();
            });
        });
    }

    public start(flowStateController: FlowStateController) {
        super.start(flowStateController);

        shuffleArray(reelLandSounds);

        let shoudPlayCloseBlockerSound: boolean = false;

        this.ucReels.forEach((reel, reelIndex) => {
            this.flowPresentationTimeline.call(() => reel.resetOnStartSpin(), undefined, 0);
            this.flowPresentationTimeline.add(
                reel.startNormalBetAnimation(),
                normalConfig.startMinDelay! + normalConfig.startReelsDelay! * reelIndex
            );

            if (
                (this.model.data.mode !== AbstractGameMode.NORMAL ||
                    (this.model.data.mode === AbstractGameMode.NORMAL &&
                        this.model.data.nextMode !== AbstractGameMode.NORMAL)) &&
                UgliestCatch.model.data.extraPositionsOpen[reelIndex]
            ) {
                reel.topBlocker.isAlreadyRevealed = false;
                this.flowPresentationTimeline.add(reel.topBlocker.startTeaseAnimation(), `<`);

                reel.bottomBlocker.isAlreadyRevealed = false;
                this.flowPresentationTimeline.add(reel.bottomBlocker.startTeaseAnimation(), `<`);
            }

            if (this.model.data.nextMode === AbstractGameMode.NORMAL) {
                reel.topBlocker.isAlreadyRevealed = false;
                reel.bottomBlocker.isAlreadyRevealed = false;

                if (
                    reel.topBlocker.state === BlockerStates.OPEN ||
                    reel.bottomBlocker.state === BlockerStates.OPEN
                ) {
                    shoudPlayCloseBlockerSound = true;

                    if (reelIndex === 1 && UgliestCatch.model.isXbet) {
                        shoudPlayCloseBlockerSound = false;
                    }
                }
                this.flowPresentationTimeline.add(reel.topBlocker.close(), `<`);
                this.flowPresentationTimeline.add(reel.bottomBlocker.close(), `<`);
            }
        });

        if (shoudPlayCloseBlockerSound) {
            this.flowPresentationTimeline.call(
                () => {
                    playSound({ name: UCSoundNames.BLOCKER_CLOSE });
                },
                undefined,
                0
            );
        }

        this.flowPresentationTimeline.resume();

        EventsManager.trigger(GameEvents.BLOCK_XBET_BUTTON);
        EventsManager.trigger(GameEvents.DISABLE_IDLE_ANIMATIONS);

        playSound({ name: UCSoundNames.REELS_SPIN });
    }

    protected onBetStarted(): void {
        EventsManager.trigger(FlowEvents.BET_STARTED);

        this.reelsView.disableIdle();
        this.backgroundView.disableIdle();

        this.ucReels.forEach((reel, index) => {
            if (UgliestCatch.model.data.extraPositionsOpen[index]) {
                const enableFishCatcherAnimation = reel.enableFishCatcher();

                this.flowPresentationTimeline.add(enableFishCatcherAnimation, 0.5);
            }
        });
    }
}
